import styled from "@emotion/styled";
import {
  SquareLock02Icon,
  Spinner,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@porchpass/ui";
import {
  ApplicationStatusBadge,
  type AppMilestoneType,
} from "src/components/ApplicationStatusBadge";
import { BaseCell } from "src/components/Table/Cells/shared";
import { formatUserDisplay } from "src/components/DealerGeneratedApplication/utils/userUtils";
import { APPLICATION_STATUSES } from "src/constants";

const CellContainer = styled(BaseCell)`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const LockIconContainer = styled.div`
  display: flex;
  align-items: center;
`;

interface LockedByUser {
  firstName?: string;
  lastName?: string;
  email?: string;
}

interface StatusCellProps {
  status: AppMilestoneType;
  isLocked?: boolean;
  isCheckingLock?: boolean;
  lockedByUser?: LockedByUser | null;
}

export const StatusCell = ({
  status,
  isLocked = false,
  isCheckingLock = false,
  lockedByUser,
}: StatusCellProps) => (
  <CellContainer>
    <ApplicationStatusBadge status={status} />
    {(status === APPLICATION_STATUSES.DRAFT ||
      status === APPLICATION_STATUSES.AWAITING_SIGNATURE ||
      status === APPLICATION_STATUSES.REOPENED_FOR_EDIT) && (
      <>
        {isCheckingLock ? (
          <Spinner size="xs" variant="blue" />
        ) : (
          isLocked && (
            <TooltipProvider delayDuration={300}>
              <Tooltip>
                <TooltipTrigger asChild>
                  <LockIconContainer>
                    <SquareLock02Icon variant="bulk-rounded" size={16} />
                  </LockIconContainer>
                </TooltipTrigger>
                <TooltipContent side="top">
                  {lockedByUser ? (
                    <>
                      This application is being edited by{" "}
                      <strong>{formatUserDisplay(lockedByUser)}</strong>
                    </>
                  ) : (
                    "This application is currently being edited by another user"
                  )}
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
          )
        )}
      </>
    )}
  </CellContainer>
);
